export class AgeFactor {
    id: number;
    insurer: string;
    age: string;
    factor: number;
    tabaco: number;
  }